import React from "react";
import {Bar} from "react-chartjs-2";
import {HiCheckCircle} from "react-icons/hi";
import {FaRegCircle} from "react-icons/fa";

import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend
} from "chart.js";
import NoDataMessage from "../../../../../components/noDataMessage";
import LoadingBarChart from "../components/loadingBarChart";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MilestoneChartPreview = ({
                                   data,
                                   loading = true,
                                   title = '',
                                   active = false,
                                   mainBackground = 'rgb(58, 70, 169)',
                                   secondaryBackground = '#ECEDF7',
                                   label = 'FP',
                                   barThickness = 10,
                                   labelsTableRowThickness = "1px",
                                   barHeight = 19.5,
                               }) => {
    const summeValues = data.map((item) => parseFloat(item.FP).toFixed(1));

    const chartData = {
        labels: data.map(() => ""), // No labels in the chart itself
        datasets: [{
            label: label,
            data: summeValues,
            backgroundColor: mainBackground,
            borderColor: mainBackground,
            borderWidth: 1,
        }],
    };

    const options = {
        indexAxis: "y", responsive: true, maintainAspectRatio: false, plugins: {
            legend: {
                display: false,
            }, title: {
                display: false
            },tooltip: {
                callbacks: {
                    label: function (context) {
                        const value = parseFloat(context.raw);
                        return `${context.dataset.label}: ${value.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}`;
                    }
                }
            }
        }, scales: {
            x: {
                beginAtZero: true, ticks: {
                    font: {
                        size: 8,
                    },
                },
            }, y: {
                display: true,
            },
        },
        barThickness: barThickness,
    };

    return (loading ? (<div className="flex justify-center items-center w-full h-full">
                <LoadingBarChart/>
            </div>) : (<div className="relative w-full">
                {data.length === 0 ? (<NoDataMessage message="No data to display"/>) : (<>
                        {/* Top Right Checkmark Icon */}
                        <div className="absolute top-2 right-2 text-blue-500">
                            {active ? (<HiCheckCircle size={30} className="fill-mainBlue"/>) : (
                                <FaRegCircle size={30} className="fill-whiteDark"/>)}
                        </div>

                        {/* Title aligned to the left */}
                        <h2 className="font-semibold text-xl text-left mb-4">{title}</h2>

                        <div className="flex w-full h-full">
                            {/* Table for labels */}
                            <div className="w-1/2 h-full overflow-auto p-2">
                                <table style={{
                                    width: "100%", borderCollapse: "collapse", fontSize: "9px", tableLayout: "fixed"
                                }}>
                                    <thead>
                                    <tr style={{borderBottom: "2px solid #ddd"}}>
                                        <th style={{
                                            textAlign: "left", fontWeight: "bold", padding: "3px", width: "1vw"
                                        }}>#
                                        </th>
                                        <th style={{
                                            textAlign: "left",
                                            fontWeight: "bold",
                                            padding: "0"
                                        }}>P-Fortschritt (Meilenstein)
                                        </th>
                                        <th style={{
                                            textAlign: "right", fontWeight: "bold", padding: "3px", width: "2vw"
                                        }}>MA
                                        </th>
                                        <th style={{
                                            textAlign: "right", fontWeight: "bold", padding: "3px", width: "15%"
                                        }}>{label}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} style={{borderBottom: "1px solid #ddd"}}>
                                            <td style={{
                                                textAlign: "left", padding: "1px", fontWeight: "bold"
                                            }}>{index + 1}</td>
                                            <td style={{
                                                padding: "1px",
                                                textAlign: "left",
                                                height: labelsTableRowThickness,
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}>{item.Fortschritt}</td>
                                            <td style={{
                                                padding: "1px", textAlign: "right",
                                            }}>{!isNaN(Number(item.MA)) ? Number(item.MA).toLocaleString('de-DE') : '-'}</td>
                                            <td style={{
                                                padding: "1px",
                                                textAlign: "right",
                                                fontWeight: "bold",
                                                backgroundColor: secondaryBackground
                                            }}>{item.FP.toLocaleString("de-DE")}</td>
                                        </tr>))}
                                    </tbody>
                                </table>
                            </div>
                            {/* Chart without labels */}
                            <div style={{
                                width: "55%",
                                height: `${(data.length) * barHeight}px`,
                                paddingTop: "19px",
                                left: "-22px",
                                position: "relative",
                                zIndex: "0",
                            }}>
                                <Bar data={chartData} options={options}/>
                            </div>
                        </div>
                    </>)}
            </div>));
};

export default MilestoneChartPreview;
